import getWacAttachmentInfo from '../../services/getWacAttachmentInfo';
import WacAttachmentStatus from 'owa-service/lib/contract/WacAttachmentStatus';
import WacAttachmentType from 'owa-service/lib/contract/WacAttachmentType';
import { action } from 'satcheljs/lib/legacy';
import { ClientAttachmentId } from 'owa-client-ids';
import { PerformanceDatapoint, DatapointStatus } from 'owa-analytics';
import {
    isServiceFetchError,
    logResponseDataForOwaServerCalls,
    logServerCallErrorMessage,
} from 'owa-server-call-logging/lib/owaServerCallLogging';

const wacUrlCache = {};
const wacEditUrlCache = {};

export default action('initializeWacUrl')(async function initializeWacUrl(
    attachmentId: ClientAttachmentId,
    isEdit: boolean,
    actionSource?: string
): Promise<WacAttachmentType> {
    const datapoint = new PerformanceDatapoint('InitializeWacUrl');
    if (actionSource) {
        datapoint.addCustomProperty('actionSource', actionSource);
    }

    const cache = isEdit ? wacEditUrlCache : wacUrlCache;
    const cacheInfo = cache[attachmentId.Id];

    if (cacheInfo) {
        if (cacheInfo.expireTime >= new Date().getTime()) {
            datapoint.addCustomProperty('ReturnFromCache', true);
            datapoint.end();
            return cacheInfo.value;
        } else {
            delete cache[attachmentId.Id];
        }
    }

    let wacAttachmentTypeResponse;
    datapoint.addCustomProperty('ReturnFromCache', false);
    try {
        wacAttachmentTypeResponse = await getWacAttachmentInfo(
            attachmentId.Id,
            isEdit,
            null,
            attachmentId.mailboxInfo && attachmentId.mailboxInfo.requestOptions,
            actionSource
        );

        if (wacAttachmentTypeResponse.Status === WacAttachmentStatus.Success) {
            cache[attachmentId.Id] = {
                expireTime: new Date().getTime() + 60 * 60 * 1000, // expire in an hour
                value: wacAttachmentTypeResponse,
            };
        }

        if (!wacAttachmentTypeResponse.WacUrl) {
            datapoint.addCustomProperty('WacUrlIsEmpty', true);
        }

        datapoint.addCustomProperty(
            'WacAttachmentResponseStatus',
            wacAttachmentTypeResponse.Status.toString()
        );
        datapoint.end();
    } catch (error) {
        if (isServiceFetchError(error)) {
            logResponseDataForOwaServerCalls(datapoint, error.response);
        }

        logServerCallErrorMessage(datapoint, error.toString());
        datapoint.endWithError(DatapointStatus.ServerError);
        throw error;
    }

    return wacAttachmentTypeResponse;
});
